import type { DetailsRequired } from '@sine/sine-core-api-types';
import type { ISelectOption } from '@sine/sine-ui-components';

export function checkDetails(
  visitorTypeDetailsRequired: Array<{ method: DetailsRequired; visitorTypeId: string }> | undefined,
  selectedVisitorType: ISelectOption | null | undefined,
  signInMethod: Array<string>,
) {
  if (!visitorTypeDetailsRequired) {
    return false;
  }

  const visitorTypeDetails = visitorTypeDetailsRequired.find(
    (details: any) => details.visitorTypeId === selectedVisitorType?.value,
  );

  return signInMethod.includes(visitorTypeDetails?.method as any);
}
